export default {"src":"/_next/static/media/icx.d26619a1.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};